import { createStore, applyMiddleware, combineReducers } from "redux";
import thunk from "redux-thunk";
import logger from "redux-logger";
import { movieReducer, favoriteReducer } from "./reducer";

const reducers = combineReducers({ movieReducer, favoriteReducer });
const middlewares = applyMiddleware(thunk, logger);

const store = createStore(reducers, middlewares);

export default store;
